/**
 * Renderer centralizado para confirmações
 * 
 * Similar ao NotificationRenderer, este componente renderiza automaticamente
 * o ConfirmModal quando há uma confirmação pendente no ConfirmationProvider.
 * 
 * Deve ser renderizado uma vez no App.tsx.
 */

import React from 'react';
import { useConfirmations } from './ConfirmationProvider';
import { ConfirmModal } from '../ui/ConfirmModal';

export function ConfirmationRenderer() {
  const { pendingConfirmation, resolveConfirmation } = useConfirmations();

  if (!pendingConfirmation) {
    return null;
  }

  return (
    <ConfirmModal
      title={pendingConfirmation.title}
      message={pendingConfirmation.message}
      confirmLabel={pendingConfirmation.confirmLabel}
      cancelLabel={pendingConfirmation.cancelLabel}
      onConfirm={() => resolveConfirmation(true)}
      onCancel={() => resolveConfirmation(false)}
    />
  );
}

